import { Observer } from 'mobx-react-lite';
import moment from 'moment';
import React from 'react';
import { useControllers } from '../../hooks/controller.hooks';
import { useStore } from '../../utils/mobx.utils';
import { HHmm } from '../../utils/time.utils';
import './BaseCalendarTimelineAxis.scss';
var BaseCalendarTimelineAxis = function (props) {
    var UI = useControllers().UI;
    var s = useStore(function () { return ({
        get hoursPerAxisStep() {
            return UI.displayMode === 'phone' ? 2 : 1;
        },
        get numberOfSteps() {
            return 24 / s.hoursPerAxisStep;
        },
        get axisSteps() {
            // 24 hours, 2 hours per step
            return Array(s.numberOfSteps).fill(null).map(function (n, i) { return moment().startOf('day').add(s.hoursPerAxisStep * i, 'hours').format(HHmm); });
        }
    }); });
    var AxisStep = function (props) {
        return React.createElement("div", { className: "BaseCalendarTimelineAxisStep" }, props.step);
    };
    return React.createElement(Observer, { children: function () { return (React.createElement("div", { className: "BaseCalendarTimelineAxis" }, s.axisSteps.map(function (step, i) { return React.createElement(AxisStep, { step: step, key: step + i }); }))); } });
};
export default BaseCalendarTimelineAxis;
